import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=21bcc9b7&scoped=true"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/legal.less?vue&type=style&index=0&id=21bcc9b7&prod&scoped=true&lang=less&external"
import style1 from "./PrivacyPolicy.vue?vue&type=style&index=1&id=21bcc9b7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bcc9b7",
  null
  
)

export default component.exports